import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { SectionHeading } from "@/components/common/SectionHeading";
import { PhilosophyPillars } from "@/components/common/PhilosophyPillars";
import { CdtStandard } from "@/components/common/CdtStandard";
import { AppointmentCTA } from "@/components/sections/AppointmentCTA";
import { Reveal } from "@/components/common/Reveal";
import { CheckCircle2 } from "lucide-react";

const values = ["Ethics before revenue", "Complete transparency", "Education-first conversations", "Precision, not guesswork", "Long-term relationships", "Respect for your time"];

export default function About() {
  return (
    <>
      <Seo title="Our Philosophy" description="The ethics-first philosophy behind the Center Of Dental Treatment." path="/about" />
      <PageHeader eyebrow="Who We Are" title="A practice built on listening" subtitle="The Center Of Dental Treatment was founded on a simple belief: patients deserve to be heard, informed, and treated with honesty." image="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1200&q=80" />

      <section className="py-16 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="text-lg leading-8 text-[var(--cdt-muted)]">We are not a high-volume clinic. We are a considered practice where diagnosis comes before treatment, where every option is explained with its trade-offs, and where your long-term oral health always takes precedence over a quick fix. Our philosophy — <span className="text-[var(--cdt-text)] font-medium">Thoughtful Dentistry, Digital Precision, Long-term Oral Health</span> — shapes every decision we make.</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-4"><div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"><PhilosophyPillars /></div></section>

      <section className="py-16 lg:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading eyebrow="How We Work" title="The CDT Standard" subtitle="A principled pathway that every patient experiences." />
          <div className="mt-12"><CdtStandard /></div>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading eyebrow="Our Values" title="What we stand for" align="center" />
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
            {values.map((v, i) => (
              <Reveal key={v} delay={(i % 3) * 0.06}>
                <div className="flex items-center gap-3 rounded-[var(--cdt-radius-sm)] bg-[var(--cdt-surface-2)] border border-[color:var(--cdt-border)] px-4 py-3">
                  <CheckCircle2 className="h-5 w-5 text-[var(--cdt-primary)] flex-shrink-0" />
                  <span className="text-sm text-[var(--cdt-text)]">{v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <AppointmentCTA />
    </>
  );
}
